import { Box, Typography, Stepper, Step, StepLabel, StepContent, Card, CardContent } from "@mui/material";
import dayjs from "dayjs";

const formatDateTime = (value) => {
	if (!value) return "-";
	return dayjs(value).format("DD MMM YYYY • hh:mm A");
};

const excludedKeys = ["id", "i_code", "createdAt", "updatedAt", "last_updated_by"];

const convertKeyName = (k) => k.replace(/_/g, " ").replace(/\b\w/g, (x) => x.toUpperCase());

const getChanges = (entry) => {
	const out = [];
	Object.keys(entry).forEach((key) => {
		if (excludedKeys.includes(key)) return;
		const val = entry[key];
		if (val === null || val === "") return;

		const formatted = typeof val === "string" && val.includes("T") ? formatDateTime(val) : val;

		out.push({
			label: convertKeyName(key),
			value: formatted,
		});
	});
	return out;
};

const HistoryVerticalStepper = ({ steps = [] }) => {
	if (!steps || steps.length === 0) {
		return (
			<Typography textAlign="center" color="gray" p={2}>
				No updates found
			</Typography>
		);
	}

	// desc sort
	const sorted = [...steps].sort((a, b) => {
		const da = new Date(a.updatedAt || a.createdAt);
		const db = new Date(b.updatedAt || b.createdAt);
		return db - da;
	});

	return (
		<Box width="100%">
			<Stepper orientation="vertical">
				{sorted.map((step, idx) => {
					const changes = getChanges(step);

					return (
						<Step key={idx} active>
							<StepLabel
								icon={<div />}
								sx={{
									"& .MuiStepIcon-root": { display: "none" },
								}}>
								<Typography fontWeight={600} fontSize={15}>
									{formatDateTime(step.updatedAt || step.createdAt)}
								</Typography>
							</StepLabel>

							<StepContent>
								<Box pl={1} mb={2}>
									<Card variant="outlined" sx={{ borderRadius: 2, boxShadow: 1 }}>
										<CardContent sx={{ p: 2 }}>
											{changes.map((field, idx2) => (
												<Box key={idx2} mb={1.2}>
													<Typography variant="body2" fontWeight={600} color="primary.main">
														{field.label}
													</Typography>

													<Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
														{field.value}
													</Typography>
												</Box>
											))}

											<Typography variant="caption" color="gray">
												Updated By: {step.last_updated_by}
											</Typography>
										</CardContent>
									</Card>
								</Box>
							</StepContent>
						</Step>
					);
				})}
			</Stepper>
		</Box>
	);
};

export default HistoryVerticalStepper;
